import { useRef, useState } from 'react';

function useDialog() {
  const resolveRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [initialData, setInitialData] = useState();

  async function open(initialData) {
    setInitialData(initialData);
    setIsOpen(true);
    return new Promise((resolve) => {
      resolveRef.current = resolve;
    });
  }

  function close(payload) {
    setIsOpen(false);
    setInitialData(undefined);
    resolveRef.current && resolveRef.current(payload);
  }

  return { isOpen, initialData, open, close };
}

export default useDialog;
